<ion-grid class="ion-no-padding user-form">
  <form [formGroup]="userForm" (ngSubmit)="updateUser()">
    <ion-row>
      <ion-col
        size="12"
        size-md="10"
        size-lg="8"
        class="ion-no-margin ion-no-padding"
      >
        <ion-row class="ion-align-items-center ion-padding-top">
          <ion-col size="12" size-lg="4">
            <ion-label class="align-label">{{
              'profile_firstname' | translate
            }}</ion-label>
          </ion-col>
          <ion-col size="12" size-lg="8">
            <ion-input
              fill="outline"
              formControlName="firstname"
              [class.is-invalid]="
                formHelper.isFieldValidCss('firstname', isFormSubmitAttempted())
              "
            >
            </ion-input>
          </ion-col>
        </ion-row>

        <ion-row class="ion-align-items-center">
          <ion-col size="12" size-lg="4">
            <ion-label class="align-label">{{
              'profile_lastname' | translate
            }}</ion-label>
          </ion-col>
          <ion-col size="12" size-lg="8">
            <ion-input
              fill="outline"
              formControlName="lastname"
              [class.is-invalid]="
                formHelper.isFieldValidCss('lastname', isFormSubmitAttempted())
              "
            >
            </ion-input>
          </ion-col>
        </ion-row>

        <ion-row class="ion-align-items-center">
          <ion-col size="12" size-lg="4">
            <ion-label class="align-label">{{
              'profile_companyname' | translate
            }}</ion-label>
          </ion-col>
          <ion-col size="12" size-lg="8">
            <ion-input
              fill="outline"
              formControlName="companyname"
              label-placement="stacked"
            ></ion-input>
          </ion-col>
        </ion-row>

        <ion-row class="ion-align-items-center">
          <ion-col size="12" size-lg="4">
            <ion-label class="align-label">{{
              'profile_vatNo' | translate
            }}</ion-label>
          </ion-col>
          <ion-col size="12" size-lg="8">
            <ion-input
              fill="outline"
              formControlName="vatno"
              label-placement="stacked"
            ></ion-input>
          </ion-col>
        </ion-row>

        <ion-row class="ion-align-items-center">
          <ion-col size="12" size-lg="4">
            <ion-label class="align-label">{{
              'profile_telephone' | translate
            }}</ion-label>
          </ion-col>
          <ion-col size="12" size-lg="8">
            <ion-input
              fill="outline"
              formControlName="telephone"
              type="tel"
            ></ion-input>
          </ion-col>
        </ion-row>

        @for (field of addressFields; track field.controlName) {
          <ion-row class="ion-align-items-center">
            <ion-col size="12" size-lg="4">
              <ion-label class="align-label">{{
                field.labelKey | translate
              }}</ion-label>
            </ion-col>
            <ion-col size="12" size-lg="8">
              <ion-input
                fill="outline"
                [formControlName]="field.controlName"
                [class.is-invalid]="
                  formHelper.isFieldValidCss(
                    field.controlName,
                    isFormSubmitAttempted()
                  )
                "
              >
              </ion-input>
            </ion-col>
          </ion-row>
        }

        <ion-row class="ion-align-items-center">
          <ion-col size="12" size-lg="4">
            <ion-label class="align-label">{{
              'profile_language' | translate
            }}</ion-label>
          </ion-col>
          <ion-col size="12" size-lg="8">
            <ion-item
              lines="none"
              class="custom-selectable-item user-form-select"
            >
              @if (languageData(); as languages) {
                <ion-select formControlName="language">
                  @for (lang of languages; track lang.id) {
                    <ion-select-option [value]="lang">
                      {{ lang.name }}
                    </ion-select-option>
                  }
                </ion-select>
              }
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row class="ion-align-items-center">
          <ion-col size="12" size-lg="4">
            <ion-label class="align-label">{{
              'profile_country' | translate
            }}</ion-label>
          </ion-col>
          <ion-col size="12" size-lg="8">
            <ion-item
              lines="none"
              class="custom-selectable-item user-form-select"
            >
              @if (countriesData(); as countries) {
                <ion-select formControlName="country">
                  @for (country of countries; track country.id) {
                    <ion-select-option [value]="country">
                      {{ country.name }}
                    </ion-select-option>
                  }
                </ion-select>
              }
            </ion-item>
          </ion-col>
        </ion-row>

        <ion-row class="ion-margin-top pb-1">
          <ion-col size="12" offset-lg="4">
            <ion-button
              type="submit"
              color="primary"
              [disabled]="!userForm.valid"
            >
              <small>{{ 'general_update' | translate }}</small>
            </ion-button>
          </ion-col>
        </ion-row>
      </ion-col>
    </ion-row>
  </form>
</ion-grid>
